import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
export type GetBankAccountFieldsFragment = {
  __typename?: "bank_accounts";
} & Pick<
  Types.Bank_Accounts,
  | "id"
  | "account_id"
  | "bank_id"
  | "account_description"
  | "opening_interest_rate"
  | "product_type"
  | "notice_days"
  | "fixed_maturity_date"
  | "currency_id"
> & {
    currency: { __typename?: "currencies" } & Pick<
      Types.Currencies,
      "id" | "name" | "prefix"
    >;
    actual_balances_aggregate: { __typename?: "actual_balances_aggregate" } & {
      aggregate?: Types.Maybe<
        { __typename?: "actual_balances_aggregate_fields" } & Pick<
          Types.Actual_Balances_Aggregate_Fields,
          "count"
        >
      >;
    };
    currency_book: { __typename?: "currency_books" } & Pick<
      Types.Currency_Books,
      "id" | "name"
    > & {
        business_unit: { __typename?: "business_units" } & Pick<
          Types.Business_Units,
          "id" | "name"
        > & {
            organisation: { __typename?: "organisations" } & Pick<
              Types.Organisations,
              "id" | "name"
            >;
          };
      };
  };

export const GetBankAccountFieldsFragmentDoc = gql`
  fragment getBankAccountFields on bank_accounts {
    id
    account_id
    bank_id
    account_description
    opening_interest_rate
    product_type
    notice_days
    fixed_maturity_date
    currency_id
    currency {
      id
      name
      prefix
    }
    actual_balances_aggregate {
      aggregate {
        count
      }
    }
    currency_book {
      id
      name
      business_unit {
        id
        name
        organisation {
          id
          name
        }
      }
    }
  }
`;
